import { api } from "./apiClient";

const ownerAPI = {
  getDashboard() {
    return api.get("/owner/dashboard", { skipTenant: true }).then((r) => r.data);
  },
  listPayments(limit) {
    return api
      .get("/owner/payments", { params: { limit }, skipTenant: true })
      .then((r) => r.data);
  },
  updateBilling(body) {
    return api
      .patch("/owner/billing", body, { skipTenant: true })
      .then((r) => r.data);
  },
  getSubscriptionCheckout(params) {
    return api
      .get("/owner/billing/checkout", { params, skipTenant: true })
      .then((r) => r.data);
  },
  initClubPayment(tenantId, body = {}) {
    return api
      .post(`/owner/clubs/${tenantId}/billing/pay/init`, body, {
        skipTenant: true,
      })
      .then((r) => r.data);
  },
  getClubSubscriptionCheckout(tenantId, params) {
    return api
      .get(`/owner/clubs/${tenantId}/billing/checkout`, {
        params,
        skipTenant: true,
      })
      .then((r) => r.data);
  },
  initPayment(body = {}) {
    return api
      .post("/owner/billing/pay/init", body, { skipTenant: true })
      .then((r) => r.data);
  },
  createClub(payload) {
    return api
      .post("/owner/clubs", payload, { skipTenant: true })
      .then((r) => r.data);
  },
  enterClubPortal(tenantId) {
    return api
      .post(`/owner/clubs/${tenantId}/enter`, {}, { skipTenant: true })
      .then((r) => r.data);
  },
  deleteClub(tenantId, confirmName) {
    return api
      .delete(`/owner/clubs/${tenantId}`, {
        data: { confirm_name: confirmName },
        skipTenant: true,
      })
      .then((r) => r.data);
  },
  getSupportMessages(params) {
    return api
      .get("/owner/support/messages", { params, skipTenant: true })
      .then((r) => r.data);
  },
  sendSupportMessage(body) {
    return api
      .post("/owner/support/messages", body, { skipTenant: true })
      .then((r) => r.data);
  },
  editSupportMessage(messageId, body) {
    return api
      .patch(`/owner/support/messages/${encodeURIComponent(messageId)}`, body, {
        skipTenant: true,
      })
      .then((r) => r.data);
  },
  deleteSupportMessage(messageId) {
    return api
      .delete(`/owner/support/messages/${encodeURIComponent(messageId)}`, {
        skipTenant: true,
      })
      .then((r) => r.data);
  },
  uploadSupportMedia(file) {
    const form = new FormData();
    form.append("file", file);
    return api
      .post("/owner/support/upload", form, {
        skipTenant: true,
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 180000,
      })
      .then((r) => r.data);
  },
  getSupportUnread() {
    return api
      .get("/owner/support/unread", { skipTenant: true })
      .then((r) => r.data);
  },
};

export default ownerAPI;
